import React, { useState } from 'react'
import moment from 'moment'

import { Redirect, Route, Switch, withRouter } from 'react-router'

import { ChooseSitePage } from '../pages/ChooseSitePage/index'
import { ComponentsPage } from '../pages/ComponentsPage'
import { ContentsPage } from '../pages/ContentsPage.js'
import { CmsContentsPage } from '../pages/CmsContentsPage.js'
import { HCP1_1A } from '../pages/HCP1-patientInfo/index.js'
import { HCP3_1 } from '../pages/HCP3-patientInfo/index.js'
import { HcpWelcome } from '../pages/HCP_Welcome'
import { Intake1Page } from '../pages/Intake1Page'
import { Intake2Page } from '../pages/Intake2Page'
import { Intake3Page } from '../pages/Intake3Page'
import { KidsActivitiesPage } from '../pages/KidsActivitiesPage/index.js'
import { KidsFaqPage } from '../pages/KidsFaq/index'
import { KidsGamesPage } from '../pages/KidsGamesPage/index.js'
import { KidsHomePage } from '../pages/KidsHomePage/index.js'
import { KidsMaskGame } from '../pages/KidsMaskGame/index.js'
import { KidsBuildGame } from '../pages/KidsBuildGame/index.js'
import { KidsSleepGame } from '../pages/KidsSleepGame/index.js'
import { KidsTourPage } from '../pages/KidsTourPage/index.js'
import { KidsVideoPage } from '../pages/KidsVideoPage/index.js'
import { KidsWakeGame } from '../pages/KidsWakeGame/index.js'
import { PainRatingPage } from '../pages/PainRatingPage'
import { Review1Page } from '../pages/Review1Page'
import { Review2Page } from '../pages/Review2Page'
import { Review3Page } from '../pages/Review3Page'
import { Review4Page } from '../pages/Review4Page'
import { WelcomeBackPage } from '../pages/WelcomeBackPage/index'
import { SimpatiaPage} from '../pages/SimpatiaPage'
import { KidsForbidden } from '../pages/KidsForbidden/index'
import WelcomePage from '../pages/Welcome/index'
import {apolloClient} from '../utils/apolloClient'
import {ADD_PAGE_ANALYTICS} from '../mutations/ADD_PAGE_ANALYTICS'
import {ADD_PAGE_VISITED} from '../mutations/ADD_PAGE_VISITED'
import {SIGN_OUT_MUTATION} from '../mutations/SIGN_OUT_MUTATION'
import Chatbot from '../organisms/Chatbot/Chatbot'


let redirectPath = '/choose-site'
if (window.location.host.includes('webinfo')) {
  redirectPath = '/contents/webinfo-01'
}


class AuthRoutes extends React.Component<any> {

  public lastPathname = ''
  public allowOnlyInactivitiy = false
  public startTime = moment()
  public timer: any
  public showChat: boolean = false

  

  public componentDidMount() {
    this.onRouteChanged(this.props.location.pathname)
    window.onbeforeunload = (event: any) => {
      this.trackRouteChange(this.lastPathname, this.startTime, 'close', 'close')
    }
    console.log(this.props.location)
    window.localStorage.setItem('userType', this.props.userType)
    
  }

  public componentWillUnmount() {
    if (this.timer) {
      clearTimeout(this.timer)
    }
  }

  public componentDidUpdate(prevProps: {location: {pathname: string}}) {
  
    if (this.props.location !== prevProps.location) {
      this.onRouteChanged(this.props.location.pathname)
    }
  }

  public render() {
    console.log(this.props.userType)
    // @ts-ignore
    return (
      <>
      {['PARENT_WEBTIPS_ES_EXTENSION'].includes(this.props.userType) && <Chatbot/>}
      <Switch>

      <Redirect path="/" exact={true} to={redirectPath} />
      <Route path="/choose-site" component={ChooseSitePage} />
      <Route path="/welcome-back" render={() => <WelcomeBackPage />}/>
      <Route path="/welcome" component={WelcomePage} />
      <Route path="/kids" component={KidsHomePage} />
      <Route path="/kids-forbidden" component={KidsForbidden} />
      <Route path="/kids-faq" component={KidsFaqPage} />
      <Route path="/kids-video" component={KidsVideoPage} />
      <Route path="/kids-tour" component={KidsTourPage} />
      <Route path="/kids-games" component={KidsGamesPage} />
      <Route path="/kids-mask-game" component={KidsMaskGame} />
      <Route path="/kids-sleep-game" component={KidsSleepGame} />
      <Route path="/kids-wake-game" component={KidsWakeGame} />
      <Route path="/kids-build-game" component={KidsBuildGame} />
      <Route path="/simpatia" component={SimpatiaPage}  />
      <Route path="/kids-activities" component={KidsActivitiesPage} />
      <Route path="/intake-1" component={Intake1Page} />
      <Route path="/intake-2" component={Intake2Page} />
      <Route path="/intake-3" component={Intake3Page} />
      <Route path="/review-1" component={Review1Page} />
      <Route path="/review-2" component={Review2Page} />
      <Route path="/review-3" component={Review3Page} />
      <Route path="/review-4" component={Review4Page} />
      <Route path="/components" component={ComponentsPage} />
      <Route path="/contents/:screenNo" component={ContentsPage} />
      <Route path="/cms-contents/:screenNo" component={CmsContentsPage} />
      <Route path="/p/:token" component={PainRatingPage} />
      {['HEALTHCARE_PROVIDER', 'HOSPITAL_MANAGER'].includes(this.props.userType) ? <Route path="/HCP_Welcome" component={HcpWelcome} /> : null}
      {['HEALTHCARE_PROVIDER', 'HOSPITAL_MANAGER'].includes(this.props.userType) ?<Route path="/HCP1-patientInfo" component={HCP1_1A} />: null}
      {['HEALTHCARE_PROVIDER', 'HOSPITAL_MANAGER'].includes(this.props.userType) ?<Route path="/HCP3-patientInfo" component={HCP3_1} />: null}
      <Redirect to="/welcome-back" />
      </Switch>
      </>
    )
  }

  public async trackRouteChange(lastPathname: string, startTime: any, endReason: string, label: string) {


    if ( this.allowOnlyInactivitiy && endReason !== 'inactivity') {
      return
    }
    const now = moment()

    let siteType = 'webtips'

    const path = lastPathname.toLocaleLowerCase()

    if (path.includes('hcp')) {
      siteType = 'hcp'
    } else if (path.includes('kids')) {
      siteType = 'kids'
    } else if (path.includes('webinfo')){
      siteType = 'webinfo'
    } else {
      siteType = 'webtips'
    }

    const duration = now.diff(this.startTime, 'seconds')

    const patientID = window.localStorage.patientID ?
      window.localStorage.patientID
        : null

    const res = await apolloClient.mutate({
      mutation: ADD_PAGE_ANALYTICS, variables: {
        startTime: this.startTime.format('YYYY-MM-DDTHH:mm:ssZ'),
        endTime: now.format('YYYY-MM-DDTHH:mm:ssZ'),
        duration,
        endReason,
        page: lastPathname,
        siteType,
        label,
        patientID,
      },
    })
  }
  private onRouteChanged(pathname: string) {


    let siteType = 'webtips'

    const path = pathname.toLocaleLowerCase()

    if (path.includes('hcp')) {
      siteType = 'hcp'
    } else if (path.includes('kids')) {
      siteType = 'kids'
    } else if (path.includes('webinfo')){
      siteType = 'webinfo'
    } else {
      siteType = 'webtips'
    }


    const res = apolloClient.mutate({
      mutation: ADD_PAGE_VISITED, variables: {
        time: moment().format('YYYY-MM-DDTHH:mm:ssZ'),
        page: pathname,
        siteType,
        patientID: null,
      },
    })

    if (this.lastPathname !== '') {
      this.trackRouteChange(this.lastPathname, this.startTime, 'changePage', pathname)
    }
    this.lastPathname = pathname
    this.startTime = moment()

    if (this.timer) {
      clearTimeout(this.timer)
    }
    this.timer = setTimeout(async () =>  {
      // inactivity === 'no site change'
      localStorage.setItem('autoLogout', 'yes')
      localStorage.clear()
      sessionStorage.clear()
      // @ts-ignore
      if(window.ReactNativeWebView !== undefined) {
        // @ts-ignore
        window.ReactNativeWebView.postMessage(JSON.stringify({name: 'logout'}), '*')
      }
      this.allowOnlyInactivitiy = true
      await this.trackRouteChange(this.lastPathname, this.startTime, 'inactivity', 'inactivity')
      await apolloClient.mutate({
        mutation: SIGN_OUT_MUTATION,
      })
      location.reload()
    }, 1000 * 60 * 30 )
  }
}

export default withRouter(AuthRoutes)



// WEBPACK FOOTER //
// ./src/routes/AuthRoutes.tsx